/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';
import Description from './FileProperties/Description';
import Download from './FileProperties/Download';
import RelatedFiles from './FileProperties/RelatedFiles';
import Series from './FileProperties/Series';
import Subtitle from './FileProperties/Subtitle';
import Tags from './FileProperties/Tags';
import Thumbnail from './FileProperties/Thumbnail';
import Title from './FileProperties/Title';
import Author from './FileProperties/Author';
import ShareButtons from 'Views/ShareButtons';
import PDFPreviewer from '../../FrontEnd/PDFPreviewer';

class DocumentView extends React.Component {
  constructor(props) {
    super(props);
    this.file = props.file;
    this.iframe = React.createRef();
  }

  componentDidMount() {
    if (this.file) {
      const isPdf = this.file.get('extension') === 'pdf';
      if (!isPdf) {
        let setTimer = () => {
          this.iFrameTimer = setTimeout(() => {
            if (!this.loaded) {
              this.iframe.current.src = this.iframe.current.src;
              setTimer();
            }
          }, 3000);
        };
        setTimer();
      }
    }


  }

  render() {
    let file = this.file;

    let details = (
      <div
        className="container"
        style={{
          background: '#fff',
          color: '#000',
          paddingTop: '12px',
          maxWidth: '100%',
          height: '100%'
        }}
      >
        <div style={{marginBottom: 10, textAlign: 'center', hyphens: 'auto'}}>
          <Thumbnail file={file} />
          <Title text={file.get('title')} />
          <Subtitle text={file.get('subtitle')} />
          <Author text={file.get('author')} />
          <Description text={file.get('description')} />
          {file.isDownloadable() ? <div style={{textAlign: 'center'}}>
            <Download
              file={file}
              name={file.get('title') + '.' + file.get('extension')}
              url={file.downloadLink}
            />
          </div> : null}
          <Series series={file.get('media_series')} />
          <RelatedFiles files={file.get('related_files')} />
          <Tags file={file} />
        </div>
      </div>
    );

    const isPdf = file.get('extension') === 'pdf';
    const src = 'https://docs.google.com/gview?url=' + encodeURIComponent(file.originalUrl(true)) + '&embedded=true';
    return (
      <div style={{height: '100%'}}>
        {FW.store.get('site').prop('hide_document_side_panel') ? null : <div
          className="col-md-3"
          id="detailsBox"
          style={{
            overflowX: 'hidden',
            overflowY: 'scroll',
            paddingTop: '10px',
            paddingLeft: '10px'
          }}
        >
          {details}
          {this.props.social.url ? (
            <ShareButtons {...this.props.social} />
          ) : (
            <ShareButtons {...this.props.social} url={window.location.href} />
          )}
        </div>}
        <div className={FW.store.get('site').prop('hide_document_side_panel') ? "col-md-12" : "col-md-9"} style={{height: '100%'}}>
          {isPdf ? <PDFPreviewer
            fileSrc={file.originalUrl(true)}
            style={{width: '100%', minHeight: '100%', height: 768}}
            /> : <iframe
            ref={this.iframe}
            onLoad={() => {
              this.loaded = true;
            }}
            src={src}
            style={{width: '100%', minHeight: '100%', height: 768}}
            />}
            </div>
      </div>
    );
  }
}

export default DocumentView;
